module.exports = __webpack_public_path__ + "static/media/valuta-immobile.dd2ece50.jpg";